import { Box, Typography } from '@mui/material'
import React from 'react'

const SectionTitle = ({ variant, header , align }) => {
  return (
    <Box sx={{textAlign: align }}>
      {header.map((item, index) => (
        <Typography
          key={index}
          variant={variant}
          sx={{
            color: item.color,
            fontWeight: item.font_weight,
            display: item.add_break ? 'block' : 'inline',
            fontSize:{ xs: '2rem', md: '2.125rem'},
          }}
        >
          {item?.text}
          {item?.add_break ? <br/> :  <span>&nbsp;</span>}
        </Typography>
      ))}
    </Box>
  )
}

export default SectionTitle